"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _styles = require("@material-ui/core/styles");

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _moduleModal = _interopRequireDefault(require("@eig-builder/module-modal"));

require("./style/tabheader.scss");

require("../header/style/image-picker-header.scss");

var _withContext = _interopRequireDefault(require("../../helpers/with-context"));

var _mobileDetectionHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/mobile-detection-helper"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _hooks = require("../../hooks");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var tabs = function tabs(showLogosTab, type, uploadOnly) {
  var tabValues = [];

  var currentBrand = (0, _runtimeConfigHelper.getRuntimeConfig)()._brand;

  var isCreativeMail = currentBrand === 'creativemail';

  if (!uploadOnly) {
    if (type === 'images') {
      tabValues.push({
        message: isCreativeMail ? 'imagepicker.stockPhotos' : 'imagepicker.unsplash',
        name: 'free-images'
      });
    }
  }

  tabValues.push({
    message: 'imagepicker.myImages',
    name: 'my-images'
  });

  if (showLogosTab) {
    tabValues.push({
      message: 'imagepicker.logos',
      name: 'my-logos'
    });
  }

  if (isCreativeMail) {
    tabValues.push({
      message: 'imagepicker.wordpressImages',
      name: 'wordpress-images'
    });
  }

  return tabValues;
};

var styles = function styles(theme) {
  return {
    iconClose: {
      height: 40,
      marginLeft: 6,
      marginRight: 10,
      marginTop: (0, _mobileDetectionHelper["default"])() ? 0 : 20,
      padding: 8
    },
    iconBack: {
      marginTop: (0, _mobileDetectionHelper["default"])() ? 0 : 20,
      marginLeft: 10
    }
  };
};

var TabHeader = function TabHeader(_ref) {
  var searchQuery = _ref.searchQuery,
      navigate = _ref.navigate,
      preSearchQuery = _ref.preSearchQuery,
      showSearch = _ref.showSearch,
      disabled = _ref.disabled,
      type = _ref.type,
      useSocialSearch = _ref.useSocialSearch,
      uploadOnly = _ref.uploadOnly,
      showLogosTab = _ref.showLogosTab,
      showAddImageButton = _ref.showAddImageButton,
      classes = _ref.classes,
      actions = _ref.actions;

  var _useActiveView = (0, _hooks.useActiveView)(),
      currentView = _useActiveView.currentView;

  var modalTabs = tabs(showLogosTab, type, uploadOnly).map(function (tab, index) {
    return _objectSpread(_objectSpread({}, tab), {}, {
      value: index,
      key: "tab-".concat(index),
      dataElementLocation: 'pop_up',
      dataElementLabel: "image-select-nav-tab-".concat(index),
      dataElementId: "image-select-nav-tab-".concat(index),
      label: /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
        message: tab.message
      }),
      index: index
    });
  });
  var currentIndex = modalTabs.findIndex(function (tab) {
    return tab.name === currentView;
  });

  var _React$useState = _react["default"].useState(currentIndex),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      activeIndex = _React$useState2[0],
      setActiveIndex = _React$useState2[1];

  if (disabled) {
    return null;
  }

  var changeViews = function changeViews(i) {
    var newViewIndex = modalTabs.findIndex(function (tab) {
      return tab.value === i;
    });
    setActiveIndex(newViewIndex);
    navigate(null, modalTabs[i].name, null);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab-header"
  }, /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Tabs, {
    tabs: modalTabs,
    onChange: changeViews,
    value: activeIndex,
    dataElementLocation: _taggingHelper.DataElementLocations.POP_UP,
    dataElementPrefix: "image-selector-nav-tabs"
  }));
};

TabHeader.propTypes = {
  searchQuery: _propTypes["default"].string,
  navigate: _propTypes["default"].func,
  preSearchQuery: _propTypes["default"].string,
  showSearch: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  useSocialSearch: _propTypes["default"].bool,
  uploadOnly: _propTypes["default"].bool,
  showLogosTab: _propTypes["default"].bool,
  classes: _propTypes["default"].any,
  actions: _propTypes["default"].array,
  showAddImageButton: _propTypes["default"].bool
};
var withStylesComponents = (0, _styles.withStyles)(styles)(TabHeader);

var _default = (0, _withContext["default"])(withStylesComponents);

exports["default"] = _default;